/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Feed_Url_RequiredInputs */

const cs_import_feed_url_required = /** @type {(inputs: Import_Feed_Url_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vložte odkaz na XML feed.`)
};

const en_import_feed_url_required = /** @type {(inputs: Import_Feed_Url_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the XML feed link.`)
};

/**
* | output |
* | --- |
* | "Paste the XML feed link." |
*
* @param {Import_Feed_Url_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_url_required = /** @type {((inputs?: Import_Feed_Url_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_Url_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_url_required(inputs)
	return cs_import_feed_url_required(inputs)
});